import { parseHex } from "./oklch";

// WCAG 2.x contrast between two colours

const toLinear = (channel: number): number => {
    const c = channel / 255;

    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
};

const relativeLuminance = (rgb: number[]): number => {
    const [r, g, b] = rgb.map(toLinear);

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

/** The contrast ratio (1–21) between two hex colours. Undefined when either isn't hex. */
export const getContrastRatio = (a: string, b: string): number | undefined => {
    const rgbA = a ? parseHex(a) : undefined;
    const rgbB = b ? parseHex(b) : undefined;

    if (!rgbA || !rgbB) {
        return undefined;
    }

    const [light, dark] = [relativeLuminance(rgbA), relativeLuminance(rgbB)].sort((x, y) => y - x);

    return (light + 0.05) / (dark + 0.05);
};

/**
 * The text colour to use on a background: the chosen one when it reads (at least
 * minRatio, 4.5 for normal text), otherwise whichever of dark and white reads better.
 * Colours that aren't hex are left as chosen.
 */
export const getReadableTextColor = (
    textColor: string,
    backgroundColor: string,
    dark: string = "#22234A",
    minRatio: number = 4.5,
): string => {
    const ratio = getContrastRatio(textColor, backgroundColor);

    if (ratio === undefined || ratio >= minRatio) {
        return textColor;
    }

    return (getContrastRatio(dark, backgroundColor) || 0) >= (getContrastRatio("#FFFFFF", backgroundColor) || 0) ?
        dark :
        "#FFFFFF";
};
